import OutdoorIcon from "../../assets/product-list-assets/wifi-outdoor.svg";
import type { ProductListGroup } from "../../types";

export const wifiOutdoor: ProductListGroup = {
  id: "wifiOutdoor",
  title: "productListGroup.wifiOutdoor.title",
  seriesLabel: "modelCompare.seriesLabel.wifiOutdoor",
  icon: {
    src: OutdoorIcon,
    width: 16,
    height: 19,
  },
};
